export default __webpack_public_path__ + "static/media/Instagram.e338991f.svg";